export default __webpack_public_path__ + "static/media/site_logo.4f754486.png";